// toggle primary menu
document.querySelector('.open-menu').addEventListener('click', (e) => {
    document.body.classList.toggle('vp-menu-open')
})

// close primary menu on click on panel-primary
document.addEventListener('click', (e) => {
    if (
        document.body.classList.contains('vp-menu-open') &&
        e.target === document.querySelector('.vp-header .panel-primary')
    ) {
        document.body.classList.remove('vp-menu-open')
    }
})

// toggle menu image
document
    .querySelector('header [is="vp-menu"]')
    .addEventListener('change', (e) => {
        const el = document.querySelector('header .images')
        const url = e.detail === null ? el.dataset.default : e.detail
        el.style.backgroundImage = `url(${url})`
    })
